<template>
    <b-container v-bind:class="[{ busy: loadingImages}, { activeEnter: dragenter }]" class="gallery opacity-transition" ref="gallery">
        <pb-spinner v-if="loadingImages"></pb-spinner>
        <b-row v-if="imageList.length > 0">
            <b-col>
                <b-row>
                    <b-col>
                        <b-pagination
                                v-model="pagination.currentPage"
                                :total-rows="filteredImages.length"
                                :per-page="pagination.perPage"
                                aria-controls="imageList"
                        ></b-pagination>
                    </b-col>
                    <b-col>
                        <b-form @submit.prevent="search">
                            <b-input-group>
                                <b-form-input id="selected-img-path"
                                              v-debounce:500="search"
                                              placeholder="Search for file.."
                                              type="text"
                                              :input="searchTerm">
                                </b-form-input>
                                <b-input-group-append>
                                    <b-input-group-text>
                                        <i class="fal fa-search"></i>
                                    </b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row v-bind:class="[{ busy: uploadingImage}, 'opacity-transition']">
                    <pb-spinner v-if="uploadingImage"></pb-spinner>
                    <b-col v-bind:key="index" md="3" class="my-3" v-for="(image,index) in images">
                        <pb-card @click.native="selectImageCallback(image.name)" :content="image.name"
                                 :img-src="image.name"></pb-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-pagination
                                v-model="pagination.currentPage"
                                :total-rows="filteredImages.length"
                                :per-page="pagination.perPage"
                                aria-controls="imageList"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import FileApi from "../../../shared/_api/file";

    export default {
        name: 'ImageGallery',
        props: {selectImageCallback: Function},
        data() {
            return {
                pagination: {
                    currentPage: 1,
                    perPage: 12
                },
                imageList: [],
                loadingImages: false,
                searchTerm: '',
                dragenter: false,
                uploadingImage: false
            };
        },
        mounted() {
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
                this.$refs.gallery.addEventListener(evt, function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }.bind(this), false);
            }.bind(this));
            this.$refs.gallery.addEventListener('dragleave', function () {
                this.dragenter = false;
            }.bind(this));
            this.$refs.gallery.addEventListener('dragenter', function () {
                this.dragenter = true;
            }.bind(this));
            this.$refs.gallery.addEventListener('drop', function (e) {
                this.uploadingImage = true;
                FileApi.upload(e.dataTransfer.files[0]).then((image) => {
                    this.imageList.push(image);
                }).finally(() => {
                    this.uploadingImage = false;
                });
            }.bind(this));
        },
        created() {
            this.loadingImages = true;
            FileApi.fetchImages().then(result => {
                this.imageList = result;
            }).finally(() => {
                this.loadingImages = false;
            })
        },
        methods: {
            search(val) {
                this.searchTerm = val;
            }
        },
        computed: {
            filteredImages() {
                return this.imageList.filter(img => img.name.includes(this.searchTerm));
            },
            images() {
                return this.filteredImages.slice(
                    (this.pagination.currentPage - 1) * this.pagination.perPage,
                    this.pagination.currentPage * this.pagination.perPage,
                );
            }
        }
    }

</script>

<style lang="scss" scoped>
    .gallery {
        min-height: 300px;
    }
    .activeEnter {
        border: 1px solid #868d95;
    }
</style>